import BaseAPI from "@/apis/base/baseApi";
import httpClient from "@/apis/base/httpclient";

class TenantAPI extends BaseAPI {
  constructor() {
    super();
  }

  apiName = "TaskGo";
  controllerName = "Tenants";

  /**
     * Lưu thông tin đơn vị
     * @param {*} payload 
     * @returns 
     */
  updateTenantInfor(payload) {
    let request = {
      url: this.getAPIUrl(),
      data: payload
    };

    return httpClient.putAsync(request);
  }
}

export default new TenantAPI();
